import {
  Box,
  CircularProgress,
  Container,
  Divider,
  Grid,
  styled,
  Typography,
  useTheme,
} from "@mui/material";

import SocialMediaPostCompact from "./SocialMediaPostCompact";
import { useInfiniteSocialMediaFeed } from "../api/getFeed";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import _cookies from "../../../shared/utils/_cookies";
import SideBar from "./Layout/SideBar";
import UserTitle from "./UserTitle";
import CreateSocialMediaPost from "./CreateSocialMediaPost";
import SocialMediaThemes from "./SocialMediaThemes";
import { useParams, useSearchParams } from "react-router-dom";
import Navbar from "../../../ui/blocks/Navbar";
import SideBarSection from "./SideBarSection";
import MobileHeader from "./Layout/MobileHeader";
import { useTenantParameters } from "../../misc/api/getTenantParameters";
import { cn } from "../../../shared/utils/cn";

const StyledContainer = styled(Container)(({ theme }) => ({
  overflow: "visible",
  height: "fit-content",
  width: "min(100vw, 500px)",
}));

export default function SocialMediaFeedPage() {
  const { themeId } = useParams();
  const [searchParams] = useSearchParams();
  const hideThemes = searchParams.get("hideThemes") === "true";
  const tenantParams = useTenantParameters();
  const showCreatePost = () => tenantParams.data?.DIREITO_DE_POSTAGEM === "S";
  const feedQuery = useInfiniteSocialMediaFeed({ pageLength: 15, themeId });
  const theme = useTheme();
  const bottomEl = useInView();
  const handleBottomEntersView = () => {
    if (feedQuery.hasNextPage && !feedQuery.isFetchingNextPage) {
      feedQuery.fetchNextPage();
    }
  };

  useEffect(() => {
    document.getElementById("navbar_container").style.position = "fixed";
    document.getElementById("navbar_toggle_button").style.marginTop = "-70px";
  }, []);
  useEffect(() => {
    if (bottomEl?.inView) {
      handleBottomEntersView();
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottomEl?.inView]);

  return (
    <>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          margin: "0 auto",
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <StyledContainer disableGutters>
          <MobileHeader />
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: 2,
                borderBottom: `1px solid ${theme.palette.grey["200"]}`,
              }}
            >
              <UserTitle
                userData={{
                  name: _cookies.getItem("auth").user?.nome,
                  pictureURL: _cookies.getItem("auth").user?.foto,
                  studentId: _cookies.getItem("auth").user?.alunoid,
                }}
                sx={{ paddingLeft: { xs: 1, md: 0 } }}
              />
              {showCreatePost() && <CreateSocialMediaPost themeId={themeId} />}
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                ".post_compact_thumbnail_restrict": {
                  minHeight: "350px",
                  position: "relative",
                },
              }}
            >
              {feedQuery?.data?.pages?.map((page) => {
                return page.map((postData) => {
                  return (
                    <>
                      <SocialMediaPostCompact postData={postData} />
                      <Divider sx={{ marginBottom: 2, marginTop: 2 }} />
                    </>
                  );
                });
              })}
              <div
                ref={bottomEl.ref}
                className="h-[350px] flex-row w-full justify-center flex item-center content-center"
              >
                {feedQuery.hasNextPage ? (
                  <CircularProgress />
                ) : (
                  <Typography variant="subtitle2">
                    Fim das postagens desse tema
                  </Typography>
                )}
              </div>
            </Grid>
          </Grid>
        </StyledContainer>

        <SideBar className={cn("left", hideThemes && "hidden")}>
          <SideBarSection title="Temas em destaque">
            <SocialMediaThemes />
          </SideBarSection>
        </SideBar>
        <Navbar />
      </Box>
    </>
  );
}
